import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import CrudMain from "./CrudMain";
import FormikForm from "./FormikForm";
import { Field, Formik } from "formik";
import MultiSelect from "../form-fields/MultiSelect";
import Select from "../form-fields/Select";
import TextInput from "../form-fields/TextInput";
import Checkbox from "../../components/form-fields/Checkbox";
import EmailInput from "../form-fields/EmailInput";
import * as yup from "yup";
import CurrencyInput from "../form-fields/CurrencyInput";
import TextArea from "../form-fields/TextArea";
import FileUpload from "../fields/FileUpload";
import request from "../../services/request";
import { useTranslation } from "react-i18next"; /* Added Line */
import { formatCurrencyWithDouble } from "../../utils";
import ReactDatePicker from "../form-fields/ReactDatePicker";
import moment from "moment";
import { DEMAND_TYPES } from "../../shared/enums";
import { ThemeContext } from '../../../context/ThemeContext';
import { toast } from "react-toastify";
import { Button } from 'react-bootstrap';

DemandCreate.propTypes = {};

function DemandCreate(props) {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [companies, setCompanies] = useState([]);
  const [combineCompanies, setCombineCompanies] = useState([]);
  const [groups, setGroup] = useState([]);
  const [mensei, setMensei] = useState([]);
  const [bedel, setBedel] = useState(null);
  const [docTypeElements, setDocTypeElements] = useState([]);
  const [index, setIndex] = useState(1);
  const validationSchema = yup.object({});
  const [t, i18n] = useTranslation(); /* Added Line */
  var ids = [];
  const [homeCompany, setHomeCompany] = useState(true);
  const [abroadCompany, setAbroadCompany] = useState(false);
  const [isActive, setIsActive] = useState(null);
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [davaliTextboxVisibility, setDavaliTextboxVisibility] = useState(false);
  const [davaciTextboxVisibility, setDavaciTextboxVisibility] = useState(false);
  const [ilgiliSirketAreaVisibility, setIlgiliSirketAreaVisibility] = useState(false);
  const [ilgiliSirketTextboxVisibility, setIlgiliSirketTextboxVisibility] = useState(false);
  const [sorumluEpostaTextboxVisibility, setSorumluEpostaTextboxVisibility] = useState(false);
  const [sorumluAdiTextboxVisibility, setSorumluAdiTextboxVisibility] = useState(false);

  const arrangeBeforePersist = (values) => {
    let payload = {
      id: values.id,
      sorumluAdi: values.sorumluAdi,
      sorumluEposta: values.sorumluEposta,
      sorumluTel: values.sorumluTel,
      dosyaTuruIds: values["dosyaTuruId_" + (index - 1)],
      konu: values.konu,
      aciklama: values.aciklama,
      durumId: values.durumId,
      davaTuru: values.davaTuru,
      sirketId: values.sirketId,
      // sorumluRolu: values.sorumluRolu,
      mudahil: values.mudahil,
      davali: values.davali,
      yonlendiriciYorum: values.yonlendiriciYorum,
      avukatYorumu: values.avukatYorumu,
      yorumlar: values.yorumlar,
      bedel: values.bedel && parseFloat(values.bedel.replaceAll(",", "")),
      szlThmBedelTuru: values.szlThmBedelTuru,
      paraBirimi: values.paraBirimi,
      dil: values.dil,
      daireNo: values.daireNo,
      icraNo: values.icraNo,
      fileIds: values.fileIds ? values.fileIds.map((f) => f.id) : [],
      talepTurId: props.talepTurId,
      taraf1: values.taraf1,
      basvurulanSirket: values.basvurulanSirket,
      vekilSirket: values.vekilSirket,
      basvurulanSirket: values.basvurulanSirket,
      ihtarEden: values.ihtarEden,
      davaTarihi: values.durusmaTarihi,
      davaliCompanyList: values.davaliCompanyList?.map(s => { return { "companyId": s } }),
      tarafCompanyList: values.tarafCompanyList?.map(s => { return { "companyId": s } }),
      onemli: values.onemliMark,
      ilgiliSirketId: values.ilgiliSirketId,
      ilgiliSirketText: values.ilgiliSirketText,
    };
    return payload;
  };

  const getDocTypeParentId = (dosyaTur) => {
    if (dosyaTur.parent) {
      ids.push(dosyaTur.parent.id);
      if (dosyaTur.parent.parent) {
        getDocTypeParentId(dosyaTur.parent);
      }
    }
  };

  const setAdaptDataForUpdate = (adaptedData) => {
    ids.reverse().forEach((dti, i) => {
      adaptedData["dosyaTuruId_" + i] = dti;
      onDocTypeChanged(dti);
    });

    setInitialValues(adaptedData);
  };

  const adaptDataForUpdate = (data) => {
    ids.push(data.dosyaTuruId);
    getDocTypeParentId(data.dosyaTur);
    let groupIds = data.companyGroup?.map((cg) => cg.id);
    onGroupChanged(groupIds);
    let adaptedData = {
      id: data.id,
      sorumluAdi: data.sorumluAdi,
      sorumluEposta: data.sorumluEposta,
      sorumluTel: data.sorumluTel,
      dosyaTuruIds: data.dosyaTuruId,
      konu: data.konu,
      aciklama: data.aciklama,
      durumId: data.durumId,
      davaTuru: data.davaTuru,
      sirketId: data.sirketId,
      group: groupIds,
      // sorumluRolu: data.sorumluRolu,
      mudahil: data.mudahil,
      davali: data.davali,
      yonlendiriciYorum: data.yonlendiriciYorum,
      avukatYorumu: data.avukatYorumu,
      yorumlar: data.yorumlar,
      bedel: data.bedel && formatCurrencyWithDouble(data.bedel),
      szlThmBedelTuru: data.szlThmBedelTuru,
      paraBirimi: data.paraBirimi,
      dil: data.dil,
      daireNo: data.daireNo,
      icraNo: values.icraNo,
      fileIds: data.fileIds,
      taraf1: data.taraf1,
      basvurulanSirket: data.basvurulanSirket,
      vekilSirket: data.vekilSirket,
      basvurulanSirket: data.basvurulanSirket,
      ihtarEden: data.ihtarEden,
      durusmaTarihi:
        data.davaTarihi && moment(data.davaTarihi).format("DD/MM/YYYY"),
      davaliCompanyList: data.davaliCompanyList,
      tarafCompanyList: data.tarafCompanyList,
      onemli: data.onemliMark,
      ilgiliSirketId: data.ilgiliSirketId,
      ilgiliSirketText: data.ilgiliSirketText,
    };

    setAdaptDataForUpdate(adaptedData);
  };

  useEffect(() => {
    if (!showModal) {
      // setCompanies([]);
    }
    getCompanies();
    getCombinedCompanies();
  }, [showModal]);

  useEffect(() => {
    if (props.updateButtonClicked) {
      onUpdateButtonClicked(props.selectedRow);
      props.setUpdateButtonClicked(false);
    }
  }, [props.updateButtonClicked]);

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setDocTypeElements([]);
    setIndex(1);
    setInitialValues({ sorumluEposta: "@" });
    setCompanies([]);
    setCombineCompanies([]);
  };
  const closeModal = () => {
    setBedel(null);
    setShowModal(false);
    setIlgiliSirketTextboxVisibility(false);
    setIlgiliSirketAreaVisibility(false);
  };

  const onBedelChanged = (val) => {
    setBedel(val);
  };

  const onGroupChanged = (groupIds, setFieldValue, _homeCompany, _abroadCompany) => {
    setGroup(groupIds);
    getCompanies(groupIds, _homeCompany, _abroadCompany);
    getCombinedCompanies(groupIds, _homeCompany, _abroadCompany);
    if (setFieldValue)
      setFieldValue('sirketId', null);
  };

  const getCompanies = (companyGroupIds, _homeCompany = homeCompany, _abroadCompany = abroadCompany) => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          companyGroupIds: companyGroupIds,
          yurtici: (_homeCompany && _abroadCompany) || (!_homeCompany && !_abroadCompany) ? null : _homeCompany,
          talepTurId: props.talepTurId
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCompanies(response.body.tableData);
      }
    });
  };

  const getCombinedCompanies = (companyGroupIds, _homeCompany = homeCompany, _abroadCompany = abroadCompany) => {
    request({
      url: "company/multi-company",
      method: "POST",
      data: {
        body: {
          companyGroupIds: companyGroupIds,
          yurtici: (_homeCompany && _abroadCompany) || (!_homeCompany && !_abroadCompany) ? null : _homeCompany,
        },
      },
    }, changeSpinnerStatus).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setCombineCompanies(response.body.tableData);
      }
    });
  };

  const typeCheck = (type, filterValues = []) => {
    let index = filterValues.findIndex((fv) => fv == type);

    if (index != -1) {
      return true;
    }

    return false;
  };

  const onDocTypeChanged = (id) => {
    if (id) {
      request({
        url: "talep-girisi/dosya-tur-config",
        method: "POST",
        data: {
          body: {
            id: id,
          },
        },
      }, changeSpinnerStatus).then((response) => {
        if (
          response.responseStatus === "SUCCESS" &&
          response.body.dosyaAltTurler.length > 0
        ) {
          let newElement = (
            <Field
              name={"dosyaTuruId_" + index}
              label={"Dosya Türü " + index}
              colNumber="6"
              component={Select}
              options={response.body.dosyaAltTurler}
              onChangeFunc={(opt) => onDocTypeChanged(opt)}
            />
          );
          setIndex(index + 1);

          setDocTypeElements((oldArray) => [...oldArray, newElement]);
        }
      });
    }
  };

  const renderAlert = () => {
    let message = "";

    if (typeCheck(
      props.talepTurId,
      [4, 16, 17, 18, 19, 20, 21, 22, 23, 25, 26, 27, 28, 49, 64, 81, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98]
    )) {
      message = t("demandCreate.turkiyeSirketleriVeTicaretHukUyari");
    }

    // if (typeCheck(
    //   props.talepTurId,
    //   [4, 16, 49, 64, 17, 20, 28, 27, 21, 18, 22, 23]
    // )) {
    //   message = t("demandCreate.ticaretHukukuUyari");
    // }

    // if (message)
    return (
      <div className="text-danger mb-3">{message}</div>
    );
  }

  const activeChange = (opt) => {
    setIsActive(opt === 1 ? true : false);
    if (!opt) setIsActive(null);
  };

  return (
    <div className={"row"}>
      <div className="col-xl-12 col-xxl-12">
        <CrudMain
          onAddButtonClicked={onAddButtonClicked}
          showModal={showModal}
          setShowModal={setShowModal}
          title={props.pageTitle}
          customAddButtonTitle={t("demandCreate.yeniTalepButton")}
          size={"lg"}
          closeModal={closeModal}
        >
          <FormikForm
            isUpdating={isUpdating}
            entityId={selectedRow && selectedRow.id}
            entityFetchId="id"
            configParameterName="talepTurId"
            configParameterValue={props.talepTurId}
            configReqType={"POST"}
            endPointUrl="talep-girisi/create"
            fetchPointUrl="yonlendirilecek-talep/find"
            editPointUrl="talep-girisi/update"
            configPointUrl="talep-girisi/config"
            arrangeBeforePersist={arrangeBeforePersist}
            adaptDataForUpdate={adaptDataForUpdate}
            closeModal={closeModal}
            setConfigData={(data) => {
              if (data.dosyaTurleri.length == 1 && !isUpdating) {
                initialValues.dosyaTuruId_0 = [data.dosyaTurleri[0].value];
                setInitialValues(initialValues);
              }
              setConfigData(data);
            }}
            initialValues={initialValues}
            validationSchema={validationSchema}
            refreshList={(data) => {
              toast.success(t("demandCreate.successCreate", { id: data?.body?.id }), {
                position: "top-right",
                autoClose: false,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
              });
              props.setRefreshList(!props.refreshList)
            }}
            okButtonText={t("tamamlaButton.gonder")}
          >
            {/* {renderAlert()} */}
            
            <div className="col-12">
              <div className="text-warning mb-3">{ t("demandCreate.sirketUyari") }</div>
            </div>

            {/* <Field
              name="active"
              label={"Aktif/Pasif?"}
              colNumber="6"
              component={Select}
              options={[
                { value: 1, label: "Aktif" },
                { value: 2, label: "Pasif" },
              ]}
              onChangeFunc={(opt) => activeChange(opt)}
            /> */}

            <Field
              name="yurticiSirketleri"
              checkboxText={t("demandCreate.turkiyeSirketleri")}
              colNumber="3"
              value={homeCompany}
              component={Checkbox}
              onChangeFunc={(check, setFieldValue) => {
                setHomeCompany(check);
                // if (!check && !abroadCompany) {
                onGroupChanged(groups, setFieldValue, check, abroadCompany);
                // setCompanies([]);
                // }
              }}
            />
            <Field
              name="yurtdisiSirketleri"
              checkboxText={t("demandCreate.yurtDisiSirketleri")}
              colNumber="3"
              value={abroadCompany}
              component={Checkbox}
              onChangeFunc={(check, setFieldValue) => {
                setAbroadCompany(check);
                // if (!check && !homeCompany) {
                onGroupChanged(groups, setFieldValue, homeCompany, check);
                // setCompanies([]);
                // }
              }}
            />
            <Field
              name="group"
              label={t("demandCreate.grup")}
              colNumber="6"
              component={MultiSelect}
              placeholder={t("formFields.allPlaceHolder")}
              /* defaultValue={-1}
              defaultLabel={"Tümü"} */
              options={
                !homeCompany && !abroadCompany
                  ? null
                  : homeCompany && abroadCompany
                    ? configData?.grupSirketleri
                    : homeCompany
                      ? configData?.grupSirketleri.filter(
                        (grup) => grup.yurtici === true
                      )
                      : configData?.grupSirketleri.filter(
                        (grup) => grup.yurtici === false
                      )
              }
              onChangeFunc={(opt, setFieldValue) => onGroupChanged(opt, setFieldValue)}
              required
            />
            <Field
              name="sirketId"
              label={t("demandCreate.grupSirketi")}
              colNumber="6"
              component={Select}
              options={companies.map(item => { return { value: item.id, label: item.name } })}
              onChangeFunc={(opt) => { typeCheck(opt, [93, 60, 90, 154, 568]) ? setIlgiliSirketAreaVisibility(true) : setIlgiliSirketAreaVisibility(false) }}
              required
            />
            <div className="form-group col-md-6">
              <Field
                name="sorumluAdi"
                label={t("demandCreate.sorumluAdi")}
                colNumber="-6"
                component={Select}
                options={configData && configData.tumKullanicilar.filter(a => a.label && a.label != '').map(a => { return { value: a.label, label: (a.label || '--') } })}
                buttonLabel = {
                  <>
                    <Button
                      className="btn-xs ml-3 px-2 py-1 rounded-circle"
                      variant="primary"
                      onClick={() => setSorumluAdiTextboxVisibility(!sorumluAdiTextboxVisibility)}
                    >
                        <i className={ "fa fa-" + (sorumluAdiTextboxVisibility ? "minus" : "plus") }/>
                    </Button>
                  </>
                }
                required
              />
              { sorumluAdiTextboxVisibility &&
                <Field
                  name="sorumluAdi"
                  label={t("demandCreate.other")}
                  colNumber="-6 hide-label"
                  component={TextInput}
                />
              }
            </div>
            { ilgiliSirketAreaVisibility &&
              <div className="form-group col-md-6">
                <Field
                  name="ilgiliSirketId"
                  label={t("demandCreate.ilgiliSirket")}
                  colNumber="-6"
                  buttonLabel = {
                    <>
                      <Button
                        className="btn-xs ml-3 px-2 py-1 rounded-circle"
                        variant="primary"
                        onClick={() => setIlgiliSirketTextboxVisibility(!ilgiliSirketTextboxVisibility)}
                      >
                          <i className={ "fa fa-" + (ilgiliSirketTextboxVisibility ? "minus" : "plus") }/>
                      </Button>
                    </>
                  }
                  component={Select}
                  options={companies.map(item => { return { value: item.id, label: item.name } })}
                  required            
                />
                { ilgiliSirketTextboxVisibility &&
                  <Field
                    name="ilgiliSirketText"
                    label={t("demandCreate.other")}
                    colNumber="-6 hide-label"
                    component={TextInput}
                  />
                }
              </div>
            }
            <div className="form-group col-md-6">
              <Field
                name="sorumluEposta"
                label={t("demandCreate.sorumluEPosta")}
                colNumber="-6"
                component={Select}
                options={configData && configData.tumKullanicilar.filter(a => a.otherValue && a.otherValue != '').map(a => { return { value: a.otherValue, label: a.otherValue } })}
                buttonLabel = {
                  <>
                    <Button
                      className="btn-xs ml-3 px-2 py-1 rounded-circle"
                      variant="primary"
                      onClick={() => setSorumluEpostaTextboxVisibility(!sorumluEpostaTextboxVisibility)}
                    >
                        <i className={ "fa fa-" + (sorumluEpostaTextboxVisibility ? "minus" : "plus") }/>
                    </Button>
                  </>
                }
                required
              />
              { sorumluEpostaTextboxVisibility &&
                <Field
                  name="sorumluEposta"
                  label={t("demandCreate.other")}
                  colNumber="-6 hide-label"
                  component={EmailInput}
                />
              }
            </div>
            <Field
              name="sorumluTel"
              label={t("demandCreate.sorumluTel")}
              colNumber="6"
              component={TextInput}
              required
            />
            {/* 
            <Field
              name="sorumluRolu"
              label={t("demandCreate.sorumluRol")}
              colNumber="6"
              component={TextInput}
            /> */}
            {typeCheck(props.talepTurId, [31, 83, 64, 90, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI]) && (
              <Field
                name="davaTuru"
                label={t("demandCreate.davaTuru")}
                colNumber="6"
                component={Select}
                options={configData && configData.davaTurleri}
              />
            )}
            <Field
              name="dosyaTuruId_0"
              label={t("demandCreate.dosyaTürü")}
              colNumber="6"
              component={MultiSelect}
              options={configData && configData.dosyaTurleri}
              onChangeFunc={(opt) => onDocTypeChanged(opt[opt.length - 1])}
              required
            />
            {docTypeElements.map((dte) => {
              return dte;
            })}
            <Field
              name="fileIds"
              label={t("demandCreate.dosya")}
              colNumber="12"
              component={FileUpload}
            />
            <Field
              name="konu"
              label={t("demandCreate.konu")}
              colNumber="12"
              component={TextArea}
              required
            />
            <Field
              name="aciklama"
              label={t("demandCreate.aciklama")}
              colNumber="12"
              component={TextArea}
              required
            />
            {typeCheck(
              props.talepTurId,
              [4, 5, 18, 31, 83, 64, 22, 16, 27, 17, 33, 80, 20, 24, 48, 81, 82, 85, 86, 88, 89, 90, 91, 92, 93, 96, 81, 98, DEMAND_TYPES.PLADIS_HACIZ, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA, DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI, DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.MP_RAPORLAMALAR, DEMAND_TYPES.PLADIS_RAPORLAMALAR, DEMAND_TYPES.PLADIS_ICRA, DEMAND_TYPES.PLADIS_YENIDAVA, DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI, DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI, DEMAND_TYPES.TH_KAMULASTIRMA]
            ) && (
                <div className="form-group col-md-6">
                  <Field
                    name="tarafCompanyList"
                    label={t(props.tarafText)}
                    buttonLabel = {
                      <>
                        <Button
                          className="btn-xs ml-3 px-2 py-1 rounded-circle"
                          variant="primary"
                          onClick={() => setDavaciTextboxVisibility(!davaciTextboxVisibility)}
                        >
                            <i className={ "fa fa-" + (davaciTextboxVisibility ? "minus" : "plus") }/>
                        </Button>
                      </>
                    }
                    colNumber="-6"
                    component={MultiSelect}
                    options={combineCompanies.map(item => { return { value: item.id, label: item.name } })}
                    required
                  />
                  {
                    davaciTextboxVisibility && <Field
                      name="taraf1"
                      label={t(props.tarafText) + ' ' + t("demandCreate.other")}
                      colNumber="-6 hide-label"
                      component={TextInput}
                    />
                  }
                </div>
              )}
            {typeCheck(props.type, [5, 6, 7]) &&
              !typeCheck(props.talepTurId, [80]) && (
                <div className="form-group col-md-6">
                  <Field
                    name="davaliCompanyList"
                    label={t(props.davaliText || "demandCreate.davali")}
                    buttonLabel = {
                      <>
                        <Button
                          className="btn-xs ml-3 px-2 py-1 rounded-circle"
                          variant="primary"
                          onClick={() => setDavaliTextboxVisibility(!davaliTextboxVisibility)}
                        >
                            <i className={ "fa fa-" + (davaliTextboxVisibility ? "minus" : "plus") }/>
                        </Button>
                      </>
                    }
                    colNumber="-6"
                    component={MultiSelect}
                    options={combineCompanies.map(item => { return { value: item.id, label: item.name } })}
                    required
                  />
                  {
                    davaliTextboxVisibility && <Field
                      name="davali"
                      label={t(props.davaliText || "demandCreate.davali") + ' ' + t("demandCreate.other")}
                      colNumber="-6 hide-label"
                      component={TextInput}
                    />
                  }
                </div>
              )}
            {((typeCheck(props.type, [4, DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI]) &&
              !typeCheck(props.talepTurId, [22, 85, 98, DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI, DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI])) ||
              typeCheck(props.talepTurId, [5, 27, 28, 29, 30, 86, 87, 81, DEMAND_TYPES.MP_SINAIHAKLARSOZLESMEHAZIRLAMA, DEMAND_TYPES.PLADIS_SOZLESMEHAZIRLANMASI, DEMAND_TYPES.PLADIS_SOZLESMEUYUSMAZLIKLAR])) && (
                <Field
                  name="dil"
                  label={t("demandCreate.dil")}
                  colNumber="6"
                  component={Select}
                  options={configData && configData.diller}
                  required
                />
              )}
            {!typeCheck(props.talepTurId, [
              70,
              DEMAND_TYPES.FMH_TOPLANTI,
              DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI,
              DEMAND_TYPES.SINAI_MULKIYET_HAKLARI,
              DEMAND_TYPES.REKLAM_SENARYOSU,
              DEMAND_TYPES.BILISIM_VE_INTERNET,
              DEMAND_TYPES.FMH_ILISKIN_HUKUKI_GORUS,
              DEMAND_TYPES.MP_MUTALAADANISMA,
              DEMAND_TYPES.FMH_EGITIM,
              DEMAND_TYPES.REKLAM_DIGER,
              DEMAND_TYPES.FMH_YENI_DAVA,
              DEMAND_TYPES.FMH_ALEYHE_DAVA,
              DEMAND_TYPES.FMH_ILISKIN_RAPORLAMALAR,
              DEMAND_TYPES.GLOBAL_HUKUK_ISLERI,
              DEMAND_TYPES.BASKANLIK_TOPLANTI,
              DEMAND_TYPES.TIO_MUTALAA,
              DEMAND_TYPES.DAVA_YENI_TALEP,
              DEMAND_TYPES.TH_KAMULASTIRMA,
              DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
              DEMAND_TYPES.PLADIS_ALEYHEACILAN,
              DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
              DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI,
              DEMAND_TYPES.TIO_DAVA_YENI_TALEP,
              DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
              DEMAND_TYPES.HACIZ_IHBARNAMELERI,
              DEMAND_TYPES.PLADIS_HACIZ,
              DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
              DEMAND_TYPES.BASIN_HUKUKU,
              DEMAND_TYPES.TIO_BASIN_HUKUKU,
              DEMAND_TYPES.SAVCILIK,
              DEMAND_TYPES.PLADIS_SAVCILIK,
              DEMAND_TYPES.TIO_SAVCILIK,
              DEMAND_TYPES.IHTARNAME_HAZIRLANMASI,
              DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI,
              DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI,
              DEMAND_TYPES.TIO_IHTARNAME,
              DEMAND_TYPES.GENEL_H_IHTARNAME,
              DEMAND_TYPES.MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
              DEMAND_TYPES.TIO_MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
              DEMAND_TYPES.PLADIS_MAHKEMELERDENGELENYAZILAR,
              DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR, 
              DEMAND_TYPES.MP_RAPORLAMALAR, 
              DEMAND_TYPES.PLADIS_RAPORLAMALAR,
              DEMAND_TYPES.TIO_RAPORLAMALAR,
              DEMAND_TYPES.FMH_RAPORLAMALAR,
              DEMAND_TYPES.IS_HUKUKU_FESIH,
              DEMAND_TYPES.DAVA_ICRA_TOPLANTI,
              DEMAND_TYPES.DAVA_ICRA_EGITIM,
              DEMAND_TYPES.TIO_SIRKETEGITIM,
              DEMAND_TYPES.MARKA_PATENT,
              DEMAND_TYPES.RESMI_KURUM_TALEP,
              DEMAND_TYPES.GENEL_H_KISISEL_VERILER_SURECLER,
              DEMAND_TYPES.HUKUKI_GORUS_TALEPLERI,
              DEMAND_TYPES.SPK_MEVZUATI,
              DEMAND_TYPES.MEVZUAT_INCELEME,
              DEMAND_TYPES.DIGER_GENEL_HUKUK,
              DEMAND_TYPES.REKABET_HUKUKU_IZIN_BASVURU,
              DEMAND_TYPES.REKABET_HUKUKU_SORUSTURMALAR,
              DEMAND_TYPES.HALKA_ACIK_SIRKET,
              DEMAND_TYPES.GENEL_HUKUK_TOPLANTI,
              DEMAND_TYPES.GENEL_HUKUK_EGITIM,
              DEMAND_TYPES.PLADIS_YENIDAVA
            ]) && (
                <Field
                  name="paraBirimi"
                  label={t("demandCreate.paraBirimi")}
                  colNumber="6"
                  component={Select}
                  options={configData && configData.paraBirimleri}
                  isDisabled={bedel === 14 || bedel === 15}
                  resetValue={bedel === 14 || bedel === 15}
                  required
                />
              )}
            {!typeCheck(props.talepTurId, [
              1,
              2,
              84,
              22,
              DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI,
              DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI,
              85,
              98,
              /*DEMAND_TYPES.FMH_YENI_DAVA,
              DEMAND_TYPES.FMH_ALEYHE_DAVA,*/
              33,
              34,
              35,
              36,
              37,
              38,
              DEMAND_TYPES.MP_MUTALAADANISMA,
              40,
              41,
              70,
              /*DEMAND_TYPES.FMH_ILISKIN_RAPORLAMALAR,
              DEMAND_TYPES.DAVA_YENI_TALEP,
              DEMAND_TYPES.GH_IS_HUKUKU,*/
              /*DEMAND_TYPES.TIO_DAVA_YENI_TALEP,*/
              DEMAND_TYPES.ICRA_TAKIBI,
              DEMAND_TYPES.PLADIS_ICRA,
              DEMAND_TYPES.TIO_ICRA_TAKIBI,
              /*DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
              DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,*/
              DEMAND_TYPES.HACIZ_IHBARNAMELERI,
              DEMAND_TYPES.PLADIS_HACIZ,
              DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
              DEMAND_TYPES.BASIN_HUKUKU,
              DEMAND_TYPES.TIO_BASIN_HUKUKU,
              DEMAND_TYPES.SAVCILIK,
              DEMAND_TYPES.PLADIS_SAVCILIK,
              DEMAND_TYPES.TIO_SAVCILIK,
              DEMAND_TYPES.MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
              DEMAND_TYPES.TIO_MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
              DEMAND_TYPES.PLADIS_MAHKEMELERDENGELENYAZILAR,
              DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR,
              DEMAND_TYPES.MP_RAPORLAMALAR, 
              DEMAND_TYPES.PLADIS_RAPORLAMALAR,
              DEMAND_TYPES.TIO_RAPORLAMALAR,
              DEMAND_TYPES.FMH_RAPORLAMALAR,
              DEMAND_TYPES.IS_HUKUKU_FESIH,
              DEMAND_TYPES.DAVA_ICRA_TOPLANTI,
              DEMAND_TYPES.YURTDISI_DAVA_VE_IHTILAFLARIN_TAKIBI_HARICI,
              DEMAND_TYPES.DAVA_ICRA_EGITIM,
              DEMAND_TYPES.TIO_SIRKETEGITIM,
              DEMAND_TYPES.MARKA_PATENT,
              DEMAND_TYPES.RESMI_KURUM_TALEP,
              DEMAND_TYPES.GENEL_H_KISISEL_VERILER_SURECLER,
              DEMAND_TYPES.HUKUKI_GORUS_TALEPLERI,
              DEMAND_TYPES.SPK_MEVZUATI,
              DEMAND_TYPES.MEVZUAT_INCELEME,
              DEMAND_TYPES.DIGER_GENEL_HUKUK,
              DEMAND_TYPES.REKABET_HUKUKU_IZIN_BASVURU,
              DEMAND_TYPES.REKABET_HUKUKU_SORUSTURMALAR,
              DEMAND_TYPES.HALKA_ACIK_SIRKET,
              DEMAND_TYPES.GENEL_HUKUK_TOPLANTI,
              DEMAND_TYPES.GENEL_HUKUK_EGITIM,
              DEMAND_TYPES.GENEL_H_IHTARNAME
            ]) && (
                <Field
                  name="szlThmBedelTuru"
                  label={t(
                    props.tahminiBedelTitle
                      ? props.tahminiBedelTitle
                      : "demandCreate.tahminiBedel"
                  )}
                  colNumber="6"
                  component={Select}
                  options={configData && configData.szlTahminiBedelTurleri}
                  onChangeFunc={(val) => onBedelChanged(val)}
                  required
                />
              )}
            {!typeCheck(props.talepTurId, [
              70,
              DEMAND_TYPES.FMH_TOPLANTI,
              DEMAND_TYPES.FMH_IHTARNAME_HAZIRLANMASI,
              DEMAND_TYPES.SINAI_MULKIYET_HAKLARI,
              DEMAND_TYPES.REKLAM_SENARYOSU,
              DEMAND_TYPES.BILISIM_VE_INTERNET,
              DEMAND_TYPES.FMH_ILISKIN_HUKUKI_GORUS,
              DEMAND_TYPES.MP_MUTALAADANISMA,
              DEMAND_TYPES.FMH_EGITIM,
              DEMAND_TYPES.REKLAM_DIGER,
              /*DEMAND_TYPES.FMH_YENI_DAVA,
              DEMAND_TYPES.FMH_ALEYHE_DAVA,*/
              DEMAND_TYPES.FMH_ILISKIN_RAPORLAMALAR,
              DEMAND_TYPES.GLOBAL_HUKUK_ISLERI,
              DEMAND_TYPES.BASKANLIK_TOPLANTI,
              DEMAND_TYPES.TIO_MUTALAA,
              //DEMAND_TYPES.ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
              //DEMAND_TYPES.TIO_ALEYHIMIZE_ACILAN_DAVANIN_TAKIBI,
              DEMAND_TYPES.HACIZ_IHBARNAMELERI,
              DEMAND_TYPES.PLADIS_HACIZ,
              DEMAND_TYPES.TIO_HACIZ_IHBARNAMELERI,
              DEMAND_TYPES.BASIN_HUKUKU,
              DEMAND_TYPES.TIO_BASIN_HUKUKU,
              DEMAND_TYPES.SAVCILIK,
              DEMAND_TYPES.PLADIS_SAVCILIK,
              DEMAND_TYPES.TIO_SAVCILIK,
              DEMAND_TYPES.IHTARNAME_HAZIRLANMASI,
              DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI,
              DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI,
              DEMAND_TYPES.TIO_IHTARNAME,
              DEMAND_TYPES.GENEL_H_IHTARNAME,
              DEMAND_TYPES.MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
              DEMAND_TYPES.TIO_MAHKEMELERDEN_GELEN_YAZILARA_CEVAP,
              DEMAND_TYPES.PLADIS_MAHKEMELERDENGELENYAZILAR,
              DEMAND_TYPES.DAVA_ICRA_HUKUKU_RAPOR,
              DEMAND_TYPES.MP_RAPORLAMALAR, 
              DEMAND_TYPES.PLADIS_RAPORLAMALAR,
              DEMAND_TYPES.TIO_RAPORLAMALAR,
              DEMAND_TYPES.FMH_RAPORLAMALAR,
              DEMAND_TYPES.IS_HUKUKU_FESIH,
              DEMAND_TYPES.DAVA_ICRA_TOPLANTI,
              DEMAND_TYPES.DAVA_ICRA_EGITIM,
              DEMAND_TYPES.TIO_SIRKETEGITIM,
              DEMAND_TYPES.MARKA_PATENT,
              DEMAND_TYPES.RESMI_KURUM_TALEP,
              DEMAND_TYPES.GENEL_H_KISISEL_VERILER_SURECLER,
              DEMAND_TYPES.HUKUKI_GORUS_TALEPLERI,
              DEMAND_TYPES.SPK_MEVZUATI,
              DEMAND_TYPES.MEVZUAT_INCELEME,
              DEMAND_TYPES.DIGER_GENEL_HUKUK,
              DEMAND_TYPES.REKABET_HUKUKU_IZIN_BASVURU,
              DEMAND_TYPES.REKABET_HUKUKU_SORUSTURMALAR,
              DEMAND_TYPES.HALKA_ACIK_SIRKET,
              DEMAND_TYPES.GENEL_HUKUK_TOPLANTI,
              DEMAND_TYPES.GENEL_HUKUK_EGITIM,
              DEMAND_TYPES.GENEL_H_IHTARNAME
            ]) && (
                <Field
                  name="bedel"
                  label={t(
                    props.bedelTitle ? props.bedelTitle : "demandCreate.bedel"
                  )}
                  colNumber="6"
                  placeholder="0,00"
                  component={CurrencyInput}
                  readOnly={bedel == 14 || bedel == 15 || bedel ==124}
                  resetValue={bedel == 14 || bedel == 15 || bedel ==124}
                  required
                />
              )}
            {typeCheck(props.talepTurId, [22, 85, 33, 98, DEMAND_TYPES.MP_YURTDISIIHTARNAMEHAZIRLANMASI, DEMAND_TYPES.PLADIS_IHTARNAME_HAZIRLANMASI]) && (
              <div className="form-group col-md-6">
                <Field
                  name="davaliCompanyList"
                  label={t("demandCreate.ihtarEden")}
                  buttonLabel= {
                    <>
                      <Button
                        className="btn-xs ml-3 px-2 py-1 rounded-circle"
                        variant="primary"
                        onClick={() => setDavaliTextboxVisibility(!davaliTextboxVisibility)}
                      >
                          <i className={ "fa fa-" + (davaliTextboxVisibility ? "minus" : "plus") }/>
                      </Button>
                    </>
                  }
                  colNumber="-6"
                  component={MultiSelect}
                  options={combineCompanies.map(item => { return { value: item.id, label: item.name } })}
                  required
                />
                {
                  davaliTextboxVisibility && <Field
                    name="ihtarEden"
                    label={t("demandCreate.ihtarEden") + ' ' + t("demandCreate.other")}
                    colNumber="-6 hide-label"
                    component={TextInput}
                  /*required*/
                  />
                }
              </div>
            )}
            {typeCheck(props.talepTurId, [
              64,
              17,
              90,
              92,
              83,
              31,
              DEMAND_TYPES.PLADIS_ALEYHEACILAN,
              DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI,
              DEMAND_TYPES.PLADIS_ICRA
            ]) && (
                <Field
                  name="mudahil"
                  label={t("demandCreate.müdahil")}
                  colNumber="6"
                  component={TextInput}
                /*required*/
                />
              )}
            {typeCheck(props.type, [5, 6, 7]) && (
              <Field
                name="daireNo"
                label={t(
                  ((props.talepTurId === 18) || (props.talepTurId === 91) || (props.talepTurId === DEMAND_TYPES.PLADIS_SAVCILIK))
                    ? "demandUpdate.savcilikNo"
                      : "demandUpdate.daireNo"
                )}
                colNumber="6"
                component={TextInput}
              /*required*/
              />
            )}
            {(typeCheck(props.type, [5, 6, 7]) && typeCheck(props.talepTurId, [DEMAND_TYPES.ICRA_TAKIBI, DEMAND_TYPES.TIO_ICRA_TAKIBI, DEMAND_TYPES.PLADIS_ICRA])) && (
                <Field
                    name="icraNo"
                    label={t("demandUpdate.icraNo")}
                    colNumber="6"
                    component={TextInput}
                    /*required*/
                />
            )}

            {typeCheck(props.talepTurId, [9]) && (
              <Field
                name="basvurulanSirket"
                label={t("demandCreate.basvuruYapilacakSirket")}
                colNumber="6"
                component={TextInput}
                required
              />
            )}

            {typeCheck(props.talepTurId, [4, 88, DEMAND_TYPES.PLADIS_VEKALETNAME_HAZIRLANMASI]) && (
              <Field
                name="vekilSirket"
                label={t("demandCreate.vekilinCalistigiSirket")}
                colNumber="6"
                component={TextInput}
              /*required*/
              />
            )}

            {typeCheck(
              props.talepTurId,
              [64, 17, 18, 26, 25, 16, 69, 80, 31, 83, 89, 90, 91, 92, 97, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.PLADIS_ICRA, DEMAND_TYPES.PLADIS_YENIDAVA, DEMAND_TYPES.TH_KAMULASTIRMA]
            ) && (
                <Field
                  name="durusmaTarihi"
                  label={t("demandCreate.durusmaTarihi")}
                  colNumber="6"
                  component={ReactDatePicker}
                />
              )}
              {typeCheck(
                  props.talepTurId, 
                  [89, 90, 92, 16, 64, 17, 91, 31, 83, 18, DEMAND_TYPES.PLADIS_SAVCILIK, DEMAND_TYPES.PLADIS_ALEYHEACILAN, DEMAND_TYPES.MP_YURTDISIALEYHEDAVATAKIBI, DEMAND_TYPES.MP_YURTDISIYENIDAVAACILMASI, DEMAND_TYPES.PLADIS_ICRA, DEMAND_TYPES.PLADIS_YENIDAVA, DEMAND_TYPES.TH_KAMULASTIRMA]) 
                  && (
                  <Field
                    name="onemliMark"
                    label={t("demandCreate.markImportant")}
                    colNumber="6"
                    component={Checkbox}
                  />
              )}
          </FormikForm>
        </CrudMain>
      </div>
    </div>
  );
}

export default DemandCreate;
